/** Type guard to determine if a security requirement is non-optional */
export const isNonOptionalSecurityRequirement = (securityRequirement) => {
    return securityRequirement !== undefined && Object.keys(securityRequirement).length > 0;
};
